var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 16C1.6665 8.08387 8.08375 1.66663 15.9998 1.66663C23.9159 1.66663 30.3332 8.08387 30.3332 16C30.3332 23.916 23.9159 30.3333 15.9998 30.3333C8.08375 30.3333 1.6665 23.916 1.6665 16ZM15.9998 3.66663C9.18832 3.66663 3.6665 9.18844 3.6665 16C3.6665 22.8115 9.18832 28.3333 15.9998 28.3333C22.8114 28.3333 28.3332 22.8115 28.3332 16C28.3332 9.18844 22.8114 3.66663 15.9998 3.66663Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6665 12C11.6665 9.60674 13.6066 7.66663 15.9998 7.66663C18.3931 7.66663 20.3332 9.60674 20.3332 12C20.3332 14.3932 18.3931 16.3333 15.9998 16.3333C13.6066 16.3333 11.6665 14.3932 11.6665 12ZM15.9998 9.66663C14.7112 9.66663 13.6665 10.7113 13.6665 12C13.6665 13.2886 14.7112 14.3333 15.9998 14.3333C17.2885 14.3333 18.3332 13.2886 18.3332 12C18.3332 10.7113 17.2885 9.66663 15.9998 9.66663Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3329 20.3333C10.3308 20.3333 7.8734 22.6683 7.6787 25.6204C7.64235 26.1715 7.16614 26.5888 6.61506 26.5525C6.06397 26.5161 5.64669 26.0399 5.68303 25.4888C5.9466 21.4925 9.27036 18.3333 13.3329 18.3333H18.6662C22.7233 18.3333 26.0437 21.4841 26.315 25.473C26.3525 26.024 25.9362 26.501 25.3852 26.5385C24.8342 26.576 24.3571 26.1597 24.3196 25.6087C24.1192 22.6621 21.6643 20.3333 18.6662 20.3333H13.3329Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeMd);
export default __webpack_public_path__ + "static/media/me-md.f43e4030.svg";
export { ForwardRef as ReactComponent };